module.exports = __webpack_public_path__ + "img/height_armhole.1cb13c67.png";